export default {"src":"/_next/static/media/Headquarters.b764752f.svg","height":24,"width":168};